import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, ValidatorFn, Validators } from '@angular/forms';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';

@Component({
    selector: 'dialog-proxyapprove-component',
    styleUrls: ['proxyapprove.dialogcomponent.css'],
    templateUrl: 'proxyapprove.dialogcomponent.html',
})
export class ProxyApproveDialogComponent implements OnDestroy, OnInit {
    private _subRelease: Subject<void> = new Subject<void>();

    ParentTypes = [
        { ID: 1, Description: 'Mother', RequiresNote: false },
        { ID: 2, Description: 'Father', RequiresNote: false },
        { ID: 3, Description: 'Guardian', RequiresNote: false },
        { ID: 4, Description: 'Other (Explain)', RequiresNote: true },
    ];
    title: string;
    message: string;
    oktext: string;
    canceltext: string;
    statement: string;
    validators: ValidatorFn[];
    IsDenial: boolean;

    proxyForm: FormGroup;

    get ParentType() {
        return this.proxyForm.get('ParentType');
    }

    constructor(
        private dialogRef: MatDialogRef<ProxyApproveDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseProxyApproveDialogOptions,
        private fb: FormBuilder
    ) {
        this.title = data.TitleText || 'Input Requested';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.statement = data.Statement || '';
        this.validators = data.Validators || null;
        this.IsDenial = data.IsDenial != null ? data.IsDenial : false;
    }

    ngOnDestroy() {
        this._subRelease.next();
        this._subRelease.complete();
    }

    ngOnInit() {
        const self = this;

        // Set up the form group
        self.proxyForm = self.fb.group({
            Checked: [null, Validators.required],
            ParentName: ['', Validators.required],
            ParentType: [null, Validators.required],
            ParentTypeNote: [''],
        });

        self.ParentType.valueChanges.pipe(takeUntil(self._subRelease)).subscribe(item => {
            let toRequire: boolean;

            toRequire = item && item.RequiresNote === true;

            const ctrl = self.proxyForm.get('ParentTypeNote');
            if (ctrl) {
                if (toRequire) {
                    ctrl.enable();
                    ctrl.setValidators(Validators.required);
                } else {
                    ctrl.disable();
                    ctrl.clearValidators();
                }

                ctrl.updateValueAndValidity({ emitEvent: false });
            }
        });
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        const self = this;
        const Proxy = self.proxyForm.value;

        self.dialogRef.close({
            ProxyParentName: Proxy.ParentName,
            ProxyRelationship: Proxy.ParentType != null ? Proxy.ParentType.ID : null,
            ProxyDescription: Proxy.ParentTypeNote,
        });
    }
}

// #region Custom Classes

export class BaseProxyApproveDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Validators?: ValidatorFn[];
    IsDenial?: boolean;
    Statement?: string;
    StudentName?: string;
}

// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/proxyapprove/proxyapprove.dialogcomponent.ts